import SpinningIcon from './SpinningIcon'

export default SpinningIcon
